import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row mt-4" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row mt-4" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }

import AppPageHeader from "@/components/app/AppPageHeader.vue";
import UserProfileForm from "@/components/customer/UserProfileForm.vue";
import RemoveAccountForm from "@/components/customer/RemoveAccountForm.vue";
import ChangePasswordForm from "@/components/customer/ChangePasswordForm.vue";
import WebPushSubscribeForm from "@/components/customer/WebPushSubscribeForm.vue";
import NotificationChannels from "@/components/customer/notificationChannels/NotificationChannelsList.vue";
import NotificationChannelForm from "@/components/customer/notificationChannels/NotificationChannelForm.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Settings")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(UserProfileForm)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ChangePasswordForm)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(RemoveAccountForm)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(WebPushSubscribeForm)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(NotificationChannels)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(NotificationChannelForm)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})